import { Navigate, Outlet } from 'react-router-dom';
import { getStoredUser } from '@/services/authentication/authService';

/**
 * Client-side gate for pages restricted to specific departments. This is a UX guard only - the
 * real enforcement is the backend's @PreAuthorize("hasAuthority('BROKER') and
 * hasAnyAuthority(...)") on the underlying endpoints, which this mirrors rather than replaces.
 */
export default function RequireDepartment({ allowed }: { allowed: string[] }) {
  const user = getStoredUser();
  if (!user?.department || !allowed.includes(user.department)) {
    return <Navigate to="/unauthorized" replace />;
  }
  return <Outlet />;
}
